import { render } from "./PermanentDemandStatus.component.vue?vue&type=template&id=1e636632"
import script from "./PermanentDemandStatus.component.vue?vue&type=script&lang=js"
export * from "./PermanentDemandStatus.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__